



























































































































































import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import { timeout, isNull } from '@/utils/common'


@Component
export default class ComponentModalEditarFornecedorOPME extends Vue {
  @Prop({ required: true, default: 'solicitacao' }) solicitacao: string

  $refs!: {
    formGrupoOpme: any,
    fornecedor1: any,
    fornecedor2: any,
    fornecedor3: any,
    cardGrupoOpme: any,
  }

  fornecedorInvalidoById(value: string | null | undefined, tipoFornecedor: string): string | boolean {
    const { getTemplateOpme } = this

    // Se o campo está vazio e segundo o template, ele não é obrigatório, segue sem validação...
    if (getTemplateOpme && !!getTemplateOpme.campos[tipoFornecedor] && !getTemplateOpme[tipoFornecedor].obrigatorio && ['', null, undefined].includes(value)) return true

    // Verifica se o template contém alguma configuração pro campo de fornecedores
    if (getTemplateOpme && !!getTemplateOpme.campos[tipoFornecedor]) {
      if (getTemplateOpme[tipoFornecedor].obrigatorio && ['', null, undefined].includes(value)) return 'Campo obrigatório'

      // Busca fornecedor na lista
      const fornecedor = this.fornecedores.find((f: any) => f.fornecedorId === value)

      // Se o fornecedor é NÃO INFORMADO, seu valor será undefined
      if (fornecedor === undefined && getTemplateOpme[tipoFornecedor].permiteNaoInformado) return 'Por favor, informe um fornecedor válido.'

      // Se hospital verifica fornecedor não homologado conforme regra do template, segue com a validação
      // if (!!getTemplateOpme[tipoFornecedor].verificaFornecedorNaoHomologadoPeloHospital && !!fornecedor && !fornecedor.homologadoHospital) return 'Este fornecedor não está homologado.'
    }
    return true
  }

  fornecedoresRules: any = {
    valid: true,
    fornecedor1Id: [v => this.fornecedorInvalidoById(v, 'fornecedor1Id')],
    fornecedor2Id: [v => this.fornecedorInvalidoById(v, 'fornecedor2Id')],
    fornecedor3Id: [v => this.fornecedorInvalidoById(v, 'fornecedor3Id')],
  }

  fornecedorChange(a: any, b: string) {
    //
  }

  loadEditarFornecedorOPMEClose: boolean = false
  loadConfirmar: boolean = false

  get loadingEditarFornecedorOPMEClose() {
    return this.loadEditarFornecedorOPMEClose
  }

  set loadingEditarFornecedorOPMEClose(value: boolean) {
    this.loadEditarFornecedorOPMEClose = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalEditarFornecedorOPME() {
    return this.getBackofficeGlobalStore.modal.modalEditarFornecedorOPME
  }

  set showModalEditarFornecedorOPME(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value })
  }

  get grupoOpmeDaSolicitacao() {
    const grupo = { ...this.getBackofficeGlobalStore[this.solicitacao].grupoOpmeDaSolicitacao }
    return grupo
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get getTemplateOpme() {
    return this.getTemplate.opmes
  }

  get fornecedores() {
    return this.getBackofficeGlobalStore.fornecedores
  }

  async closeModalEditarFornecedorOPME() {
    this.loadingEditarFornecedorOPMEClose = true
    await timeout(100)
    this.showModalEditarFornecedorOPME = false
    this.loadingEditarFornecedorOPMEClose = false
    this.resetValidacaoFornecedores()
    this.getBackofficeGlobalStore.clearFornecedores()
  }

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    if (!isNull(id1) && !isNull(id2) && !isNull(id3)) return id1 === id2 || id1 === id3 || id2 === id3
    if (!isNull(id1) && !isNull(id2) && isNull(id3)) return id1 === id2
    if (!isNull(id1) && isNull(id2) && !isNull(id3)) return id1 === id3
    if (isNull(id1) && !isNull(id2) && !isNull(id3)) return id2 === id3
    return false
  }

  async confirmar() {
    this.loadingConfirmar = true

    if (this.validarDuplicatas()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Um OPME não pode ter fornecedor(es) duplicado(s)!', icon: 'warning', color: '#C62828', timeout: 4500 })
      this.loadingConfirmar = false
      return
    }

    if (this.validarFornecedores()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Existe(m) fornecedor(es) não informado(s) ou não homologado(s) abaixo', icon: 'warning', color: '#C62828', timeout: 4500 })
      this.loadingConfirmar = false
      return
    }

    const formAutorizacao = ['AguardandoOperadora', 'AutorizadaParcial', 'AutorizadaAceitaMedico', 'Autorizada'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)
      ? this.preserveFormAutorizacao()
      : false

    const cotacaoExtraGrupo = ['AnalisePreCotacao'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)
      ? this.preserveCotacaoOperadoraExtraGrupo()
      : false

    const request = await this.getBackofficeGlobalStore.updateGrupoOpmeDaSolicitacao(this.payload())

    if (request.success) {
      const method = this.solicitacao === 'solicitacao' ? 'getSolicitacaoById' : 'getSolicitacaoAlteradaById'
      const id = this.solicitacao === 'solicitacao' ? this.getBackofficeGlobalStore.solicitacao.id : this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoId

      await this.getBackofficeGlobalStore[method](id)

      if (formAutorizacao) {
        this.getBackofficeGlobalStore.setFormAutorizacao(formAutorizacao)
      }

      if (cotacaoExtraGrupo) {
        this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupo(cotacaoExtraGrupo)
      }

      EventBus.$emit('setSnackbar', { show: true, text: 'Fornecedores atualizados com sucesso!', icon: 'done', color: '#2E7D32' })
      this.closeModalEditarFornecedorOPME()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao atualizar os fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingConfirmar = false
  }

  preserveFormAutorizacao() {
    const solicitacaoCirurgia = { ...this.getBackofficeGlobalStore.solicitacao }

    return {
      protocoloOPME: solicitacaoCirurgia.protocoloOPME,
      protocoloOperadora: solicitacaoCirurgia.protocoloOperadora,
      autorizacaoValidade: solicitacaoCirurgia.autorizacaoValidade,
      autorizacaoObservacao: solicitacaoCirurgia.autorizacaoObservacao,
      operadoraSenha: solicitacaoCirurgia.operadoraSenha,
      operadoraSenhaProvisoria: solicitacaoCirurgia.operadoraSenhaProvisoria,
      operadoraQuantidadeDiasAutorizado: solicitacaoCirurgia.operadoraQuantidadeDiasAutorizado,
      statusAguardandoOperadora: solicitacaoCirurgia.statusAguardandoOperadora,
    }
  }

  preserveCotacaoOperadoraExtraGrupo() {
    const solicitacaoCirurgia = { ...this.getBackofficeGlobalStore.solicitacao }
    return { ...solicitacaoCirurgia.cotacaoOperadorasExtraGrupo }
  }

  validarDuplicatas() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      const fornecedor1 = this.$refs.fornecedor1[i].value
      const fornecedor2 = this.$refs.fornecedor2[i].value
      const fornecedor3 = this.$refs.fornecedor3[i].value
      isFormValid.push(this.possuiOMesmoFornecedor(fornecedor1, fornecedor2, fornecedor3))
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === true)
  }

  validarFornecedores() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      isFormValid.push(this.$refs.formGrupoOpme[i].validate())
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (!form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === false)
  }

  async pointError(index: number) {
    const card = this.$refs.cardGrupoOpme[index].$el
    if (card) {
      card.style.background = 'rgba(255,0,0,.05)'
      await timeout(7500)
      card.style.background = 'transparent'
    }
  }

  resetValidacaoFornecedores() {
    for (let i = 0; i < this.grupoOpmeDaSolicitacao.length; i++) {
      if (this.$refs.formGrupoOpme[i]) {
        this.$refs.formGrupoOpme[i].resetValidation()
        this.$refs.formGrupoOpme[i].reset()
      }
    }
  }

  payload() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore[this.solicitacao]
    const grupos = grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        y.push({
          opmeId: x.opmeId,
          fornecedor1Id: x.fornecedor1Id,
          fornecedor2Id: x.fornecedor2Id,
          fornecedor3Id: x.fornecedor3Id,
        })
        return y
      }, [])

      acc.push({
        grupoOpmeDaSolicitacaoId: obj.id,
        grupoOpmeId: obj.grupoOpmeId,
        opmes,
      })

      return acc
    }, [])

    grupos.forEach((grupo: any) => {
      grupo.opmes.map((op: any) => {
        const opme = op
        Object.entries(opme).forEach(([key, value]) => {
          // @ts-ignore
          if (['', null, undefined].includes(value)) {
            delete opme[key]
          }
        })
        return opme
      })
    })

    return {
      solicitacaoId: this.solicitacao === 'solicitacaoAlterada' ? this.getBackofficeGlobalStore[this.solicitacao].solicitacaoId : this.getBackofficeGlobalStore[this.solicitacao].id,
      gruposOpme: grupos,
    }
  }
}
